import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Helper } from 'src/models/helper.models';
import { SupportRequest } from 'src/models/support-request.models';
import { UiElementsService } from '../services/common/ui-elements.service';
import { ApiService } from '../services/network/api.service';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css']
})
export class SupportComponent implements OnInit {
  private subscriptions = new Array<Subscription>();
  supportRequest: SupportRequest;

  constructor(private router: Router, private translate: TranslateService,
    private uiElementService: UiElementsService, private apiService: ApiService) { }

  ngOnInit() {
    let userMe = Helper.getLoggedInUser();
    this.supportRequest = new SupportRequest(userMe.name, userMe.email, userMe.mobile_number);
  }

  ngOnDestroy() {
    for (let sub of this.subscriptions) sub.unsubscribe();
    this.uiElementService.dismissLoading();
  }

  submit() {
    if (this.supportRequest && this.supportRequest.message) {
      this.translate.get(["supporting", "supporting_success", "something_wrong"]).subscribe(values => {
        this.uiElementService.presentLoading(values["supporting"]);
        this.subscriptions.push(this.apiService.submitSupport(this.supportRequest).subscribe(res => {
          this.uiElementService.dismissLoading();
          this.uiElementService.showSuccessToastr(values["supporting_success"]);
          this.router.navigate(["dashboard"]);
        }, err => {
          console.log("submitSupport", err);
          this.uiElementService.dismissLoading();
          this.uiElementService.showErrorToastr(values["something_wrong"]);
        }));
      });
    } else {
      this.translate.get("err_valid_support_msg").subscribe(value => this.uiElementService.showErrorToastr(value));
    }
  }
}

